import axios from 'axios';
import store from '../store/index';
import { checkLoginAndExecute } from './wx-getOpenId';
// const Url = 'http://222.83.181.124:8886/hospitalWeChat_his6_api';
  // const Url = 'http://127.0.0.1:8886/his6_api';
//const wxUrl = 'http://www.yunhaiweikang.com/his6_v-2.5.2'
//const Urlimg = 'http://222.83.181.124:8886/hospitalWeChat_his6_api'

//const Url = 'http://www.texfybjy.com:8005/hospitalWeChat_his6_api';
//const wxUrl = 'http://www.texfybjy.com/his6_v-2.5.2'
//const Urlimg = 'http://www.texfybjy.com:8005/hospitalWeChat_his6_api'

const Url = 'http://www.texfybjy.cn:8886/hospitalWeChat_his6_api';
// const Url = 'http://127.0.0.1:8886/his6_api';
const wxUrl = 'http://www.texfybjy.cn/his6_v-2.5.2'
const Urlimg = 'http://www.texfybjy.cn:8886/hospitalWeChat_his6_api'

axios.defaults.timeout = 8000;
axios.defaults.baseURL = Url;

const getToken = () =>{
	// let token = localStorage.getItem('token')
	let token = store.state.token
	return token||''
}

//http request 拦截器
axios.interceptors.request.use(
	config => {
		config.data = JSON.stringify(config.data);
		// config.data = data
		config.headers = {
			'Content-Type': 'multipart/form-data',
			// 'Content-Type': 'application/json',
			'Content-Type': 'application/x-www-form-urlencoded',
			'token': getToken()
		}
		return config;
	},
	error => {
		return Promise.reject(err);
	}
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
	return response
}, err => {
	if (err && err.response) {
		switch (err.response.status) {
			case 400:
				console.log('错误请求')
				break;
			case 401:
				console.log('未授权，请重新登录')
				break;
			case 403:
				console.log('拒绝访问')
				break;
			case 404:
				console.log('请求错误,未找到该资源')
				break;
			case 405:
				console.log('请求方法未允许')
				break;
			case 408:
				console.log('请求超时')
				break;
			case 500:
				console.log('服务器端出错')
				break;
			case 501:
				console.log('网络未实现')
				break;
			case 502:
				console.log('网络错误')
				break;
			case 503:
				console.log('服务不可用')
				break;
			case 504:
				console.log('网络超时')
				break;
			case 505:
				console.log('http版本不支持该请求')
				break;
			default:
				console.log(`连接错误${err.response.status}`)
		}
	} else {
		console.log('连接到服务器失败')

	}
	return Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function Get(url, data) {
      return new Promise((resolve, reject) => {
        axios.get(url, {
            data: data
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
				reject(err)
			})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function Post(url, data) {
	
      return new Promise((resolve, reject) => {
        // data = JSON.stringify(data)
        axios.post(url, data)
          .then(response => {
            resolve(response);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data) {
      return new Promise((resolve, reject) => {
        axios.patch(url, data)
          .then(response => {
            resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data) {
      return new Promise((resolve, reject) => {
        axios.put(url, data)
          .then(response => {
            resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}
/**
 * delete
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletefn(url, params) {
      return new Promise((resolve, reject) => {
        axios.delete(url, params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
				reject(err.data)
			})
    });
}


//上传图片的方法
function updaImg(url, formData, handle) {
	let instance = axios.create({
		baseURL: Url,
		// baseURL: 'http://192.168.100.35:8086/hospitalWeChat_his6_api',
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	instance.post(url, formData).then(res => {
		handle(res.data);
	}).catch(error => {
		console.log(error);
	})
};

export default {
	Get,
	Post,
	patch,
	put,
	deletefn,
	updaImg,
	Url,
	Urlimg,
	wxUrl
}
